module.exports = __webpack_public_path__ + "img/490.52fca32e.jpg";